
































import { defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'

export default defineComponent({
    name: 'CreateLeadPopout',
    setup() {
        const { steps, isVisible } = useCreateLeadForm()

        return {
            steps,
            isVisible,
        }
    },
})
